module.exports = __webpack_public_path__ + "static/media/DSC_3008.642c6e9a.JPG";